<template>
  <div class="debug-selection">
    <div class="debug-item">
      This area supports testing by providing means of changing the date and player. When changing the date,
      all functionality below will act as if this was the current date and time. Please be aware that the time
      entered matters. The deadline is set to be Monday 5pm EST. So if you are EST then a time of Monday, 10pm (2200) will
      yield tournaments for the next week. You can enter and withdraw tournaments at will. Once entered they will show
      up in the withdrawal part. Please be aware that this server runs in testing mode. Operation might be a bit slow.
    </div>
    <div class="debug-item">
      Set the current date (local time)
      <el-date-picker
        class="width-adapted"
        v-model="dateValueToBeUsed"
        type="datetime"
        format="yyyy/MM/dd HH:mm A"
        @change="stateDateChanged"
      ></el-date-picker>Player
      <el-input
        class="width-adapted"
        size="medium"
        placeholder="Please enter a player id"
        v-model="playerIdentifierToBeUsed"
        @blur="statePlayerChanged"
      ></el-input>
    </div>
  </div>
</template>

<style scoped>
.debug-selection {
  border: 2px solid orangered;
  padding: 5px;
  margin-bottom: 10px;
}

.debug-item {
  padding: 5px;
}

.width-adapted {
  max-width: 220px;
  margin: 0px 20px;
}
</style>

<script>
import { Loading } from "element-ui";
import moment from "moment";
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      dataForDate: null,
      playerIdentifierToBeUsed: "318516"
    };
  },
  momunted() {
    this.updatePlayer(this.playerIdentifierToBeUsed);
  },
  methods: {
    ...mapActions("singlesEntrySystem", ["updateDate", 'updatePlayer']),
    statePlayerChanged(value) {
      console.log('Emitting debugPlayerChanged: ' + value.target.value );
      this.$emit('debugPlayerChanged', value.target.value);
      let loader = Loading.service({
        target: "#selection-tabs",
        fullscreen: false
      });
      this.updatePlayer(value.target.value).then(() => {
        loader.close();
        this.$notify({
          title: "Player changed",
          message: "Changed the player that is being impersonated"
        });
      }).catch((error) => {
        loader.close();
        this.$notify({
          title: "Error",
          message: "Could not change the player. Most probably it is not in the database."
        });
      });
    },
    stateDateChanged(value) {
      let loader = Loading.service({
        target: "#selection-tabs",
        fullscreen: false
      });
      this.updateDate(moment(value)).then(() => {
        loader.close();
      });
      this.$notify({
        title: "Date changed",
        message: "Changed date and reloading data from server"
      });
    }
  },
  computed: {
    ...mapGetters('singlesEntrySystem', ['currentDate']),
    wtaDateTime: function() {
      let dt = moment(this.currentDate.valueOf());
      return dt.tz("America/New_York").format();
    },
    dateValueToBeUsed: {
      get: function() {
        if (this.dataForDate === null) {
          this.dataForDate = new Date(this.currentDate.valueOf());
        }
        return this.dataForDate;
      },
      set: function(value) {
        if (this.dataForDate !== value) {
          this.dataForDate = value;
        }
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/widgets/DebugHeaderWithSelection.vue